import React, { useState, useEffect } from "react";
import { Navbar } from "./components/Navbar";
import { Video } from "./components/ui/video";
import { motion, AnimatePresence } from "framer-motion";

function App() {
  const [step, setStep] = useState(0);
  const [visible, setVisible] = useState(true);
  const [timer, setTimer] = useState(45);

  const segments = [
    {
      title: "🎵 Pre-Service Worship",
      type: "preService",
      duration: 45,
      backgroundMusic: "/assets/audio/intro-music.mp3",
      backgroundImage: "/assets/images/pre-service.png",
    },
    {
      title: "👨‍💼 Call to Worship & Prayer",
      type: "avatar",
      video: "/assets/videos/call-to-prayer.mp4",
      duration: 50,
    },
    {
      title: "🎶 Opening Worship & Praise",
      videoId: "YTeWThXzavs",
      duration: 240,
    },
    {
      title: "🎵 Second Worship & Praise",
      videoId: "NOHqRwc3ztw",
      duration: 240,
    },
    {
      title: "💝 Offering Time",
      type: "offering",
      duration: 60,
      audio: "/assets/audio/offering-announcement.mp3",
      music: "/assets/audio/giving.mp3",
      image: "/assets/images/offering-banner.jpg",
    },
    {
      title: "🎵 Third Worship & Praise",
      videoId: "Z-ln__MWpKA",
      duration: 240,
    },
    {
      title: "🎵 Fourth Worship & Praise",
      videoId: "GhSHXxlv19c",
      duration: 240,
    },
    {
      title: "👨‍💼 Pastor's Introduction",
      type: "avatar",
      video: "/assets/videos/pastor-intro.mp4",
      duration: 30,
    },
    {
      title: "📚 Sermon of the Day",
      videoId: "RXv_aEgV5t4",
      duration: 240,
    },
    {
      title: "🚔 Closing Prayer",
      videoId: "f-8EQgQ4QQo",
      duration: 90,
    },
    {
      title: "🎶 Continuous Praise & Worship",
      videoId: "eZBejrwrb38",
      loop: true,
    },
  ];

  const current = segments[step];

  useEffect(() => {
    let countdown;
    if (current.type === "preService") {
      countdown = setInterval(() => {
        setTimer((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);
    }
    return () => clearInterval(countdown);
  }, [step, current.type]);

  useEffect(() => {
    let timerId;
    if (!current.loop) {
      timerId = setTimeout(() => {
        setVisible(false);
        setTimeout(() => {
          setStep((prev) => prev + 1);
          setVisible(true);
          setTimer(30);
        }, 1000);
      }, current.duration * 1000);
    }
    return () => clearTimeout(timerId);
  }, [step, current.duration, current.loop]);

  return (
  <>
    <Navbar />
    <div className="container text-center mt-5">
      <h1 className="mb-4 fw-bold">True Gospel Chapel INTL</h1>

      <AnimatePresence mode="wait">
        {visible && (
          <motion.div
            key={step}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
          >
            <h3 className="mb-3">{current.title}</h3>

            {current.type === "preService" ? (
              <div>
                <img
                  src={current.backgroundImage}
                  alt="Pre-Service Background"
                  className="img-fluid rounded shadow mb-3"
                  style={{ width: "100%", maxHeight: "650px", objectFit: "cover" }}
                />
                <h2
                  className={`mt-3 fw-bold ${
                    timer <= 10 ? "text-danger blink" : "text-primary"
                  }`}
                >
                  Service begins in: {timer} seconds
                </h2>
                <audio src={current.backgroundMusic} autoPlay />
              </div>
            ) : current.type === "offering" ? (
              <div>
                <img
                  src={current.image}
                  alt="Offering Banner"
                  className="img-fluid rounded shadow mb-3"
                  style={{ maxHeight: "300px", objectFit: "cover" }}
                />
                <audio src={current.audio} autoPlay />
                <audio src={current.music} autoPlay loop />
              </div>
            ) : current.type === "avatar" ? (
              <video
                src={current.video}
                autoPlay
                controls
                className="w-100 rounded shadow"
              />
            ) : (
              <Video videoId={current.videoId} loop={current.loop} />
            )}
          </motion.div>
        )}
      </AnimatePresence>

      <footer className="mt-5 p-3 bg-light text-center">
        <p className="mb-0">© 2025 eChurch Service. All rights reserved.</p>
      </footer>
    </div>
</>
  );
}

export default App;


